import { Attributes, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";

@NeoModel
export default class ColumnConfigurationLookup extends ModelBase {

    public staticColumnSpecID: number = 0;

    public staticFileSpecID: number = 0;

    @Rules.StringLength(1000)
    @Rules.Required()
    public description: string = "";

    @Rules.Required()
    @Attributes.Integer()
    public columnNumber: number = 0;

    @Rules.StringLength(100)
    @Rules.Required()
    public fileFieldName: string = "";

    @Rules.StringLength(100)
    @Rules.Required()
    public databaseFieldName: string = "";

    @Rules.StringLength(20)
    @Rules.Required()
    public dataType: string = "";

    public allowsNullsInd: boolean = false;

    public isUniqueInd: boolean = false;

    public generatesTransactionRecordInd: boolean = false;

    public isCurrencyInd: boolean = false;

    public isCountryInd: boolean = false;

    public ignoreColumnInd: boolean = false;

    public dateFormat: string = "";

    public fileSpecColumnCount: number = 0;

    public updatedColumnCount: boolean = false;

    public fileSpecPropertiesConcatenated: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.columnNumber < 1, "Column number must be greater than zero.");
        rules.failWhen(d => (d.dateFormat === undefined || d.dateFormat === "") && d.dataType === "Datetime", "Date format must be populated for datetime types.");
        rules.failWhen(n => Number.isNaN(Number(n.columnNumber)), "Column number must be a number.");
        rules.infoWhen(c => c.columnNumber > 0 && c.updatedColumnCount, "Updating the column number may result in this file spec's columns being re-ordered.")
    }
}